module.exports = __webpack_public_path__ + "static/media/zeroxense-black-logo.ffd99fce.svg";